function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Descriptions, Form, Drawer, Modal, DatePicker, Input, Tag, Space } from 'antd';
import { Table } from 'react-bootstrap';
import { Search as SearchIcon, Eyedropper, BootstrapReboot, GraphUpArrow, CashCoin, PenFill, Capsule } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import PatientView from "../components/PatientView";
import NewSample from "../components/forms/NewSample";
import SetLaboResult from "../components/forms/SetLaboResult";
import EditLaboResult from "../components/forms/EditLaboResult";
import ManageOrder from "../components/ManageOrder";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Neurology = function Neurology() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItem = _useState0[0],
    setCurrentQueueItem = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    currentQueueItemElement = _useState10[0],
    setCurrentQueueItemElement = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentMedicalItem = _useState12[0],
    setCurrentMedicalItem = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    searchId = _useState14[0],
    setSearchId = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isOrderModalOpen = _useState16[0],
    setIsOrderModalOpen = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    customers = _useState18[0],
    setCustomers = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalCash = _useState20[0],
    setTotalCash = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    dataChanged = _useState22[0],
    setDataChanged = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isDataLoading = _useState24[0],
    setIsDataLoading = _useState24[1];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
    }
  };
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};
  useEffect(function () {
    setDataChanged(false);
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep = response.data.departments.filter(function (d) {
          return d.dcode == 'NEU';
        });
        if (dep.length > 0) setCurrentDept(dep[0]);
        axios.get(Common.baseApiUrl + "getdailychqueue/" + dep[0].id.toString()).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});

    //GET CASHIER DATA

    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getdailycash/' + Common.currentUser.id.toString())]).then(function (response) {
      setIsDataLoading(false);
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
      if (response[1].data.status == 200) {
        setTotalCash(response[1].data.totalCash);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 30
                }), "File d'attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte(s) prescrit(s)"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(q.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (item) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "red",
                                icon: /*#__PURE__*/_jsx(Capsule, {
                                  size: 15
                                }),
                                children: /*#__PURE__*/_jsx("b", {
                                  children: item.medical_item.label
                                })
                              }, item.medical_item.id);
                            })
                          })
                        }), /*#__PURE__*/_jsxs("td", {
                          children: [/*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              setCurrentQueueItem(q);
                              setIsOrderModalOpen(true);
                            },
                            children: "revoir le rapport"
                          }), /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "CONSULTER"
                            })
                          })]
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BootstrapReboot, {
                  size: 30
                }), "Trait\xE9(s)"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte (s) prescrit(s)"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(q.created_at).toLocaleDateString('fr')
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "vertical",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (item) {
                              return /*#__PURE__*/_jsx(Tag, {
                                color: "red",
                                icon: /*#__PURE__*/_jsx(Capsule, {
                                  size: 15
                                }),
                                children: /*#__PURE__*/_jsx("b", {
                                  children: item.medical_item.label
                                })
                              }, item.medical_item.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              setCurrentQueueItem(q);
                              setIsOrderModalOpen(true);
                            },
                            children: "Revoir la prescription"
                          })
                        })]
                      }, q.id);
                    })
                  })]
                })
              })
            }, 3)]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          md: 2,
          className: "chi_side"
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      destroyOnClose: true,
      visible: isOrderModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      onClose: function onClose() {
        setIsOrderModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsxs("b", {
        children: ["RAPPORT D'INTERVENTION", /*#__PURE__*/_jsx(PenFill, {
          size: 20
        })]
      }),
      width: "70%",
      children: currentQueueItem && /*#__PURE__*/_jsx(_Fragment, {})
    })]
  });
};
export default Neurology;